import QueueableRequest from './QueueableRequest';
import { PASSWORD_RESET_OPTIONS_ENDPOINT } from '../../config/api';
import { bindQueryParams } from '../../helpers/url';

export default class PasswordResetOptionsRequest extends QueueableRequest {
  constructor(msisdn) {
    super(bindQueryParams(PASSWORD_RESET_OPTIONS_ENDPOINT, { msisdn }));
  }
}
